import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { Members } from '@air/api';
import { reportErrorToBugsnag } from '@air/utils-error';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';
import { getWorkspaceMembersKey } from './useGetWorkspaceMembers';

export const useUpdateWorkspaceMembers = () => {
  const { currentWorkspace } = useCurrentWorkspace();
  const queryClient = useQueryClient();

  const updateWorkspaceMembers = useCallback(
    async (...params: Parameters<typeof Members.update>) => {
      try {
        const response = await Members.update(...params);

        if (currentWorkspace?.id) {
          await queryClient.invalidateQueries({ queryKey: getWorkspaceMembersKey(currentWorkspace?.id) });
        }

        return response;
      } catch (error) {
        throw reportErrorToBugsnag({
          error,
          context: 'Failed to update workspace members',
          metadata: {
            data: {
              members: JSON.stringify(...params),
            },
          },
        });
      }
    },
    [currentWorkspace?.id, queryClient],
  );

  return {
    updateWorkspaceMembers,
  };
};
